import { render, staticRenderFns } from "./updHsii.vue?vue&type=template&id=2d0a4be4"
import script from "./updHsii.vue?vue&type=script&lang=js"
export * from "./updHsii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports